import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditReservationComponent } from './edit-reservation.component';
import { ReservationService } from '../reservations.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular/src/aggrid.module';
import { MyDatePickerModule } from 'mydatepicker';
import { VehiclesService } from '../../vehicles/vehicles.service';
import { ProvidersService } from '../../providers/providers.service';
import { RiderService } from '../../riders/rider.service';
import { RiderNotesService } from '../../riders/rider-notes/rider-notes.service';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { Trip2ThemeModule } from '../../../trip2-theme/trip2-theme.module';
import { EditReservationFormComponent } from './edit-reservation-form/edit-reservation-form.component';
import { CallTypesService } from '../../call-types/call-types.service';
import { OnDemandDriversService } from '../../on-demand-drivers/on-demand-drivers.service';
import { CompaniesService } from '../../companies/companies.service';
import { DriversService } from '../../drivers/drivers.service';
import { DropDownStatusModule } from '../../A2-utils/drop-down-status/drop-down-status.module';
import { ReservationNotesModule } from '../reservation-notes/reservation-notes.module';
import { TripHistoryChangeModule } from '../trip-history-change/trip-history-change.module';
import { AutoCompleteFacilitiesModule } from '../../A2-utils/auto-complete-facilities/auto-complete-facilities.module';
import { ClientStatusManagerModule } from '../../clientModules/client-status-manager/client-status-manager.module';
import { ReservationChangeProviderModule } from '../reservation-change-provider/reservation-change-provider.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { SignalrScheduleService } from '../../A2-utils/signal-r/signalr-schedule.service';
import { SearchLocationTripModule } from '../../A2-utils/search-location-trip/search-location-trip.module';
import { TripStatusChangeModule } from '../trip-status-change/trip-status-change.module';
import { PayorsService } from '../../payors/payors.service';
import { GoogleMapsModule } from '../../A2-utils/google-maps/google-maps.module';
import { TripEditDriverVehicleModule } from '../trip-edit-driver-vehicle/trip-edit-driver-vehicle.module';
import { TextMaskModule } from 'angular2-text-mask';
import { EditStandingOrderComponent } from './edit-standing-order/edit-standing-order.component';
import { SurveyModule } from '../../survey/survey.module';
import { RidersModule } from '../../riders/riders.module';
import { ChangeStatusToCompleteModule } from '../change-status-to-complete/change-status-to-complete.module';
import { ChangeBillingStatusModule } from 'app/pages/A2-utils/change-billing-status/change-billing-status.module';
import { ManifestModule } from '../../A2-utils/manifest/manifest.module';
import { MapRouteModule } from '../../A2-utils/map-route/map-route.module';
import { ReportClaimsComponent } from './report-claims/report-claims.component';
import { CropperModule } from '../../A2-utils/cropper/cropper.module';
import { RiderModule } from '../../rider/rider.module';
import { ServiceProviderModule } from '../../service-provider/service-provider.module';
import { EditBillingModule } from './edit-billing/edit-billing.module';
import { TripManifestModule } from '../../A2-utils/trip-manifest/trip-manifest.module';
import { ReasonsDelayModule } from '../reasons-delay/reasons-delay.module';
import { LyftService } from '../../../core/services/lyft.service';
import { StartDateFormComponent } from './edit-standing-order/components/start-date-form/start-date-form.component';
import { ProviderBillingComponent } from './provider-billing/provider-billing.component';
import { ClientBillingComponent } from './client-billing/client-billing.component';
import { InputTimeModule } from 'app/utils/input-time/input-time.module';
import { DateRangeAvailableUpdateSoModule } from 'app/utils/date-range-available-update-so/date-range-available-update-so.module';
import { ChangeTimeComponent } from './change-time/change-time.component';
import { ButtonSendProviderComponent } from './button-send-provider/button-send-provider.component';
import { UberService } from 'app/core/services/uber.service';
import { AlertTextModule } from 'app/utils/alert-text/alert-text.module';
import { EncounterHistoryComponent } from './encounter-history/encounter-history.component';
import { NoteTemplateChipsModule } from '../../../utils/note-template-chips/note-template-chips.module';
import { ValidationsTripService } from 'app/core/helpers/validations-trip.service';
import { PlanService } from 'app/core/services/plan.service';
import { LiveTripService } from 'app/public/services/live-trip.service';
import { UploadsService } from '../../A2-utils/uploads.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AgGridModule.withComponents([]),
        MyDatePickerModule,
        MyDateRangePickerModule,
        Trip2ThemeModule,
        DropDownStatusModule,
        ReservationNotesModule,
        TripHistoryChangeModule,
        AutoCompleteFacilitiesModule,
        ClientStatusManagerModule,
        ReservationChangeProviderModule,
        DirectivesModule,
        SearchLocationTripModule,
        TripStatusChangeModule,
        GoogleMapsModule,
        TripEditDriverVehicleModule,
        TextMaskModule,
        SurveyModule,
        RidersModule,
        ChangeStatusToCompleteModule,
        ChangeBillingStatusModule,
        ManifestModule,
        MapRouteModule,
        CropperModule,
        RiderModule,
        ServiceProviderModule,
        EditBillingModule,
        TripManifestModule,
        ReasonsDelayModule,
        InputTimeModule,
        DateRangeAvailableUpdateSoModule,
        AlertTextModule,
        NoteTemplateChipsModule
    ],
  declarations: [
    EditReservationComponent,
    EditReservationFormComponent,
    EditStandingOrderComponent,
    ReportClaimsComponent,
    StartDateFormComponent,
    ProviderBillingComponent,
    ClientBillingComponent,
    ChangeTimeComponent,
    ButtonSendProviderComponent,
    EncounterHistoryComponent
  ],
  exports: [
    EditReservationComponent,
    EditReservationFormComponent,
    EditStandingOrderComponent
  ],
  providers: [
    ReservationService,
    VehiclesService,
    ProvidersService,
    RiderService,
    RiderNotesService,
    CallTypesService,
    OnDemandDriversService,
    CompaniesService,
    DriversService,
    SignalrScheduleService,
    PayorsService,
    LyftService,
    UberService,
    ValidationsTripService,
    PlanService,
    LiveTripService,
    UploadsService
  ]
})
export class EditReservationModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-reservation.module.ts